import { Button } from "primereact/button"
import { useState } from "react"
import CreateElaborationButton from "../CreateElaborationButton"
import ListElaborationButton from "../ListElaborationButton"

const ElaborationsButton = ()=>{
    const [showPages, setShowPages] = useState(false)
    
    const handlePage = (e)=>{
        e.preventDefault()
        if(!showPages){
            setShowPages(true)
        }else{
            setShowPages(false)
        }    
    }
    
    return (
        <>
            <Button onClick={handlePage}>Elaborazioni <i className='pi pi-sort-down-fill' style={{marginLeft:'10px'}}></i> </Button>
            {
                showPages && (
                    <div className="setupButton__ShowButtons">
                        <CreateElaborationButton/>
                        <ListElaborationButton/>
                    </div>
                )
            }
        </>
    )
}

export default ElaborationsButton